<template>
  <div class="page-add-task">
	  <validation-observer ref="addTaskRules">
		  
		  <b-form>
		  	
		  	<b-card-code
		  	    :title="$t('Diagnostic Tasks Setting')"
		  	>
		  	  
		  	    <b-row>
		  	      <b-col md="12">
					<b-form-group :label="$t('Task type')" class="required-field">
					  <validation-provider
					    #default="{ errors }"
					    :name="$t('Task type')"
					    rules="required"
					  >
					    <b-form-radio-group
					        v-model="task.taskDiagnosisType"
					        :options="taskTypes"
					        class="mb-1"
					        value-field="diagnosisProtocolIdentifier"
					        text-field="diagnosisProtocolString"
							:disabled="isView"
					    />
					    <small class="text-danger">{{ errors[0] }}</small>
					  </validation-provider>	
					</b-form-group>  
		  	      </b-col>
		  	
		  	      <b-col md="12" v-if="!task.taskDiagnosisType" class="checkbox-group">
					  <b-form-checkbox
					    v-model="task.obdSetting[obdOption.id]"
					    value="1"
					    unchecked-value="0"
					    v-for="(obdOption, index) in obdOptions"
					  	:disabled="isView"
						@change="onChangeObdSettingModel()"
					  >
					    {{ obdOption.title }}
					  </b-form-checkbox>
					<validation-provider
					  #default="{ errors }"
					  :name="$t('OBD Model')"
					  rules="required"
					>
					  <b-form-input
					  hidden
					  v-model="isObdSettingModel"/>
					  <small class="text-danger">{{ errors[0] }}</small>
					</validation-provider>
		  	      </b-col>
		  	
		  	      <b-col md="12" v-if="task.taskDiagnosisType==1" class="checkbox-group">
		  	    
					<b-row>
					<b-col md="3">
						<b-form-checkbox
						    v-model="task.udsSetting[udsOption.id]"
						    value="1"
						    unchecked-value="0"
						    v-for="(udsOption, index) in udsOptions"
							:disabled="isView"
							@change="onChangeUdsSetting()"
						>
						  {{ udsOption.title }}
						</b-form-checkbox>
						<validation-provider
						  #default="{ errors }"
						  :name="$t('UDS Option')"
						  rules="required"
						>
						  <b-form-input
						  hidden
						  v-model="isUdsSettingModel"/>
						  <small class="text-danger">{{ errors[0] }}</small>
						</validation-provider>
						<b-form-textarea
						  placeholder=""
						  rows="3"
						  disabled
						  :value="dicdiagudsmeasureddataTypesValue"
						  v-if="task.udsSetting.taskUdsReadMeasuredData==1"
						/>
					</b-col>
					<b-col md="4" v-if="!isView && task.udsSetting.taskUdsReadMeasuredData==1">
						<div class="mb-1">{{$t('Selection Area')}}</div>
						<b-table
						  ref="selectableTable"
						  selectable
						  select-mode="multi"
						  :items="dicdiagudsmeasureddataTypesL"
						  :fields="taskUdsReadMeasuredDataStringFields"
						  responsive
						  class="mb-0"
						  @row-selected="onRowSelectedL"
						>
						  <template #cell(avatar)="data">
						    <b-avatar :src="data.value" />
						  </template>
						
						  <template #cell(status)="data">
						    <b-badge :variant="status[1][data.value]">
						      {{ status[0][data.value] }}
						    </b-badge>
						  </template>
						</b-table>
					</b-col>
					<b-col class="mt-3" v-if="!isView && task.udsSetting.taskUdsReadMeasuredData==1" md="1" style="text-align: center;">
						<b-button
						    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
						    variant="primary"
						    class="mr-1 mb-1"
						    @click="addToR"
						>
						  >>
						</b-button>
						
						<b-button
						    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
						    variant="primary"
						    class="mr-1 mb-1"
						    @click="addToL"
						>
						  <<
						</b-button>
					</b-col>
					<b-col md="4" v-if="!isView && task.udsSetting.taskUdsReadMeasuredData==1">
						<div class="mb-1">{{$t('Selected Area')}}</div>
						<b-table
						  ref="selectableTable"
						  selectable
						  select-mode="multi"
						  :items="dicdiagudsmeasureddataTypesR"
						  :fields="taskUdsReadMeasuredDataStringFields"
						  responsive
						  class="mb-0"
						  @row-selected="onRowSelectedR"
						>
						  <template #cell(avatar)="data">
						    <b-avatar :src="data.value" />
						  </template>
						
						  <template #cell(status)="data">
						    <b-badge :variant="status[1][data.value]">
						      {{ status[0][data.value] }}
						    </b-badge>
						  </template>
						</b-table>
					</b-col>
					</b-row>
					
					
					
					
		  	      </b-col>
		  	
		  	      <b-col md="12" v-if="task.taskDiagnosisType==2" class="checkbox-group">
		  	        <b-form-checkbox
		  	            v-model="task.wwhobdSetting[j1939Option.id]"
		  	            value="1"
		  	            unchecked-value="0"
		  	            v-for="(j1939Option, index) in j1939Options"
						:disabled="isView"
						@change="onChangeWwhObdSetting()"
		  	        >
		  	          {{ j1939Option.title }}
		  	        </b-form-checkbox>
					<validation-provider
					  #default="{ errors }"
					  :name="$t('WWH-OBD Option')"
					  rules="required"
					>
					  <b-form-input
					  hidden
					  v-model="isWwhObdSettingModel"/>
					  <small class="text-danger">{{ errors[0] }}</small>
					</validation-provider>
		  	      </b-col>
		  	
		  	      <b-col md="12" v-if="task.taskDiagnosisType==3" class="checkbox-group">
		  	        <b-form-checkbox
		  	            v-model="task.j1939Setting[j1939Option.id]"
		  	            value="1"
		  	            unchecked-value="0"
		  	            v-for="(j1939Option, index) in j1939Options"
						:disabled="isView"
						@change="onChangeJ1939Setting()"
		  	        >
		  	          {{ j1939Option.title }}
		  	        </b-form-checkbox>
					<validation-provider
					  #default="{ errors }"
					  :name="$t('J1939 Option')"
					  rules="required"
					>
					  <b-form-input
					  hidden
					  v-model="isJ1939SettingModel"/>
					  <small class="text-danger">{{ errors[0] }}</small>
					</validation-provider>
		  	      </b-col>
		  	
		  	
		  	      
		  	    </b-row>
		  	  
		  	
		  	</b-card-code>
		  	
		  	<b-card-code
		  	    :title="$t('Communication Setting')"
		  	>
		  		<b-row>
		  				
		  			<b-col md="12">
					  <b-form-group :label="$t('Communication Type')" class="required-field">
					    <validation-provider
					      #default="{ errors }"
					      :name="$t('Communication Type')"
					      rules="required"
					    >
					      <b-form-radio-group
					          v-model="task.taskCommunication"
					          :options="communications"
					          class="mb-1"
					          value-field="communicationIdentifier"
					          text-field="communicationString"
							  :disabled="isView"
					      />
					      <small class="text-danger">{{ errors[0] }}</small>
					    </validation-provider>
					  </b-form-group>		
		  			  
		  			</b-col>	
		  					  				
		  			<b-col md="3" v-if="task.taskCommunication!=2">
		  			  <b-form-group :label="$t('CAN Interface')">
		  			    <v-select
		  			        v-model="task.canSetting.taskComCanInterface"
		  			        :options="diccandevicesTypes"
		  					:reduce="canDevicesTypeString => canDevicesTypeString.canDevicesTypeIdentifier"
		  					label="canDevicesTypeString"
		  					:placeholder="$t('Please select')+$t('CAN Interface')"
							:disabled="isView"
		  			    />
		  			  </b-form-group>
		  			</b-col>	  
		  			
		  			<b-col md="3" v-if="task.taskCommunication!=2 && task.canSetting.taskComCanInterface==3">
		  			  <b-form-group :label="$t('PassThru Interface')">
		  			    <v-select
		  			        v-model="task.canSetting.taskComPassthruInterface"
		  			        label="canPassthruString"
		  			        :options="diccanpassthruTypes"
							:reduce="canPassthruString => canPassthruString.canPassthruIdentifier"
							:placeholder="$t('Please select')+$t('PassThru Interface')"
							:disabled="isView"
		  			    />
		  			  </b-form-group>
		  			</b-col>
		  				
		  			<b-col md="3" v-if="task.taskCommunication!=2">
		  			  
		  			  <b-form-group :label="$t('CAN Channel')">
		  			    <cleave
		  			      id="number"
		  			      v-model="task.canSetting.taskComCanChannelId"
		  			      class="form-control"
		  			      :raw="false"
		  			      :options="options.number"
		  				  :placeholder="$t('Please input')+$t('CAN Channel')"
		  				  :disabled="isView"
		  			    />
		  			  </b-form-group>
		  			</b-col>
		  			
		  			<b-col md="3" v-if="task.taskCommunication!=2">
		  				<b-form-group>
		  				  <label></label>
		  				  <b-form-checkbox
		  				      v-model="task.canSetting.taskComCanUseFd"
		  				      value="1"
		  				      unchecked-value="0"
		  					  class="mt-1"
		  					  :disabled="isView"
		  				  >
		  				    {{$t('Use CAN FD')}}
		  				  </b-form-checkbox>
		  				</b-form-group>
		  			</b-col>
		  			
		  			<b-col md="4" v-if="task.taskCommunication==2">
		  			  <b-form-group :label="$t('DOIP Source IP')">
						<validation-provider
						  #default="{ errors }"
						  :name="$t('DOIP Source IP')"
						  rules="ipAddress"
						>
						  <b-form-input
						  :disabled="isView"
						  :placeholder="$t('Please input')+$t('DOIP Source IP')"
						  v-model="task.doipModelDTOSetting.taskComDoipSourceIp"/>
						  <small class="text-danger">{{ errors[0] }}</small>
						</validation-provider>
		  			  </b-form-group>
		  			</b-col>
		  			
		  			<b-col md="4" v-if="task.taskCommunication==2">
		  			  <b-form-group :label="$t('Ecu IP')">
						<validation-provider
						  #default="{ errors }"
						  :name="$t('Ecu IP')"
						  rules="ipAddress"
						>
						  <b-form-input
						  :disabled="isView"
						  :placeholder="$t('Please input')+$t('Ecu IP')"
						  v-model="task.doipModelDTOSetting.taskComDoipEcuIp" />
						  <small class="text-danger">{{ errors[0] }}</small>
						</validation-provider>  
		  			    
		  			  </b-form-group>
		  			</b-col>
		  			
		  			<b-col md="4" v-if="task.taskCommunication==2">
		  			  <b-form-group :label="$t('Ecu EID')">
						<validation-provider
						  #default="{ errors }"
						  :name="$t('Ecu EID')"
						  rules="macAddress"
						>
						  <b-form-input
						  :disabled="isView"
						  :placeholder="$t('Please input')+$t('Ecu EID')"
						  v-model="task.doipModelDTOSetting.taskComDoipEcuEid"/>
						  <small class="text-danger">{{ errors[0] }}</small>
						</validation-provider>  
		  			  </b-form-group>
		  			</b-col>	
		  			
		  			
		  		</b-row>
		  	
		  	</b-card-code>
		  	
		  	
		  	<b-card-code
		  	    :title="$t('Information Setting')"
		  	>
		  		<b-row>
		  			
		  			<b-col md="6">
		  			  <b-form-group :label="$t('Task Name')" class="required-field">
						  <validation-provider
						    #default="{ errors }"
						    :name="$t('Task Name')"
						    rules="required"
						  >
						    <b-form-input 
							:disabled="isView"
							:placeholder="$t('Please input')+$t('Task Name')"
							v-model="task.taskName"/>
						    <small class="text-danger">{{ errors[0] }}</small>
						  </validation-provider>
						  
		  			  </b-form-group>
		  			</b-col>
		  			
		  			<b-col md="6">
		  			  <b-form-group :label="$t('Task Description')">
		  			    <b-form-input 
						:disabled="isView"
						:placeholder="$t('Please input')+$t('Task Description')"
						v-model="task.taskDescirption"/>
		  			  </b-form-group>
		  			</b-col>
		  			
		  			<b-col md="6">

		  			  <b-form-group :label="$t('Device')" class="required-field">
						<validation-provider
						  #default="{ errors }"
						  :name="$t('Device')"
						  rules="required"
						>
						  <v-select
						      :disabled="isView"
						      v-model="task.taskDeviceIdentifier"
						      :options="taskDevices"
							  :placeholder="$t('Please select')+$t('Device')"
						  />
						  <small class="text-danger">{{ errors[0] }}</small>
						</validation-provider>
					
		  			  </b-form-group>
		  			</b-col>
		  			
		  			<!--<b-col md="4">
		  			  <b-form-group>
		  			    <label>{{$t('Task Exec Status')}}:</label>
						<validation-provider
						  #default="{ errors }"
						  :name="$t('Task Exec Status')"
						  rules="required"
						>
						  <v-select
						      v-model="task.taskExecStatus"
						      label="diagTaskStatusString"
						      :options="taskStatus"
							  :placeholder="$t('Please select')+$t('Task Exec Status')"
						  	:reduce="diagTaskStatusString => diagTaskStatusString.diagTaskStatusId"
						  />
						  <small class="text-danger">{{ errors[0] }}</small>
						</validation-provider>
						
		  			  </b-form-group>
		  			</b-col>-->
		  			
		  				<b-col md="6">
		  					<b-form-group>
		  					  <label></label>
		  					  <b-form-checkbox
							      :disabled="isView"
		  					      v-model="task.taskNeedEmailNotification"
		  					      value="1"
		  					      unchecked-value="0"
								  class="mt-1"
		  					  >
		  					    {{$t('Task Need Email Notification')}}
		  					  </b-form-checkbox>
		  					</b-form-group>
		  				</b-col>
		  			
		  			<!-- submit and reset -->
		  			<b-col md="12" v-if="!isView">
		  			  <b-button
		  			      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
		  			      variant="primary"
		  			      class="mr-1"
		  			      @click="addTask"
		  			  >
		  			    {{$t("Submit")}}
		  			  </b-button>
		  			  <b-button
		  			      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
		  			      type="reset"
		  			      variant="outline-secondary"
		  			  >
						{{$t("Reset")}}
		  			  </b-button>
		  			</b-col>
		  			
		  		</b-row>
		  	
		  	</b-card-code>
		  	
		  </b-form>
		    
		  
	  </validation-observer>
	
  </div>
  
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import {
  BRow, BCol, BFormGroup, BFormInput, BFormCheckbox, BForm, BButton,BFormSelect, BFormRadioGroup, BFormTextarea, BTable
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import vSelect from 'vue-select'
import { 
	getTaskTypes, 
	getCommunication, 
	getTaskDevices, 
	//getTaskStatus, 
	getDiccanpassthruType, 
	getDiccandevicesType, 
	addTask, 
	getDicdiagudsmeasureddataType,
	getTask
	} from '@/api/task'
import Cleave from 'vue-cleave-component'

/*
export const credit = extend('credit', {
    validate: validatorCreditCard,
    message: 'Please enter positive number!',
  })

export const validatorCreditCard = creditnum => {
  const cRegExp = /^(?:3[47][0-9]{13})$/
  const validCreditCard = cRegExp.test(creditnum)
  return validCreditCard
}*/

export default {
  components: {
    BCardCode,
	ValidationProvider,
	ValidationObserver,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BFormSelect,
	BFormTextarea,
	BTable,
    BFormRadioGroup,
    vSelect,
	Cleave,
  },
  directives: {
    Ripple,
  },
  name: 'Detail',
  props: {
  	isView:{
  	  type: Boolean,
  	  default: false
  	}  
  },
  data() {
    return {
      taskTypes: [],
	  taskUdsReadMeasuredDataStringFields: [{ key: 'udsMeasuredDataGroupName', label: 'Group Name' }, { key: 'udsMeasuredDataIdentifier', label: 'Identifier' }, { key: 'udsMeasuredDataGroupDescription', label: 'Description' }],
      //OBD选项
      obdOptions: [
        {id:'taskObdMode1', title:'Mode 1 - Powertrain diagnostic data'},
        {id:'taskObdMode2', title:'Mode 2 - Freeze frame data'},
        {id:'taskObdMode3', title:'Mode 3 - Emission-related diagnostic trouble codes'},
        {id:'taskObdMode4', title:'Mode 4 - Clear/reset emission-related diagnostic trouble codes'},
        {id:'taskObdMode6', title:'Mode 6 - Monitoring test restults for specific system'},
        {id:'taskObdMode7', title:'Mode 7 - Emission-related trouble codes current or last'},
        {id:'taskObdMode9', title:'Mode 9 - Vehicle information'},
        {id:'taskObdModeA', title:'ModeA - Emission-related trouble codes with permanent status'},
      ],
      udsOptions: [
        {id:'taskUdsEcuIdentification', title:'ECU Identification'},
        {id:'taskUdsVin', title:'VIN'},
        {id:'taskUdsFaultMemory', title:'Fault Memory'},
        {id:'taskUdsFreezeFrames', title:'Freeze Frames'},
        {id:'taskUdsReadMeasuredData', title:'Read Measured Data'},
      ],
      j1939Options: [
        {id:'taskReadiness', title:'Readiness'},
        {id:'taskCurrentData', title:'Current Data'},
        {id:'taskRationality', title:'Rationality'},
        {id:'taskFaultCodes', title:'Fault Codes'},
        {id:'taskFreezeFrames', title:'Freeze Frames'},
        {id:'taskTestResults', title:'Test Results'},
        {id:'taskInformation', title:'Information'},
        {id:'taskTracking', title:'Tracking'},
        {id:'taskIumpr', title:'IUMPR'},
        {id:'taskClearReset', title:'Clear/Reset'},
      ],
      communications:[],
      taskDevices:[],
      //任务状态选项
      //taskStatus:[],
	  //CAN Passthru的类型选项
	  diccanpassthruTypes:[],
	  //CAN硬件类型列表选项
	  diccandevicesTypes:[],
	  //测量项列表选项(左边)
	  dicdiagudsmeasureddataTypesL:[],
	  //测量项列表选项(右边)
	  dicdiagudsmeasureddataTypesR:[],
	  //测量项列表选项(左边)(选中项)
	  dicdiagudsmeasureddataTypesLActive:[],
	  //测量项列表选项(右边)(选中项)
	  dicdiagudsmeasureddataTypesRActive:[],
	  //测量项选中展示值
	  dicdiagudsmeasureddataTypesValue:null,
	  options: {
	    number: {
	      numeral: true,
	      numeralThousandsGroupStyle: 'thousand',
	    },
	  },
      task:{
        taskDiagnosisType: 0,
        taskName: null,
        taskDeviceIdentifier: null,
        taskNeedEmailNotification: 0,
        taskDescirption: null,
        canSetting: {
          taskComCanInterface: 0,
          taskComPassthruInterface: 0,
          taskComCanChannelId: 0,
          taskComCanUseFd: 0
        },
        doipModelDTOSetting: {
          taskComDoipSourceIp: null,
          taskComDoipEcuIp: null,
          taskComDoipEcuEid: null
        },
        taskCommunication: 1,
        //taskExecStatus: 2,  //默认为Idle
		obdSetting: {
		  taskObdMode1: 0,
		  taskObdMode2: 0,
		  taskObdMode3: 0,
		  taskObdMode4: 0,
		  taskObdMode6: 0,
		  taskObdMode7: 0,
		  taskObdMode9: 0,
		  taskObdModeA: 0
		},
		udsSetting: {
		  taskUdsEcuIdentification: 0,
		  taskUdsVin: 0,
		  taskUdsFaultMemory: 0,
		  taskUdsFreezeFrames: 0,
		  taskUdsReadMeasuredData: 0,
		  taskUdsReadMeasuredDataString: []
		},
		j1939Setting: {
		  taskReadiness: 0,
		  taskCurrentData: 0,
		  taskRationality: 0,
		  taskFaultCodes: 0,
		  taskFreezeFrames: 0,
		  taskTestResults: 0,
		  taskInformation: 0,
		  taskTracking: 0,
		  taskIumpr: 0,
		  taskClearReset: 0
		},
		wwhobdSetting: {
		  taskReadiness: 0,
		  taskCurrentData: 0,
		  taskRationality: 0,
		  taskFaultCodes: 0,
		  taskFreezeFrames: 0,
		  taskTestResults: 0,
		  taskInformation: 0,
		  taskTracking: 0,
		  taskIumpr: 0,
		  taskClearReset: 0
		},
      },
	  required,
	  //是否填写obd选项
	  isObdSettingModel:null,
	  //是否填写uds选项
	  isUdsSettingModel:null,
	  //是否填写wwh-obd选项
	  isWwhObdSettingModel:null,
	  //是否填写j1939选项
	  isJ1939SettingModel:null,
    }
  },
  created() {
	localize(this.$i18n.locale)
    this.getTaskTypes()
    this.getCommunication()
    this.getTaskDevices()
    //this.getTaskStatus()
	this.getDiccanpassthruType()
	this.getDiccandevicesType()
	this.getDicdiagudsmeasureddataType()
	if(this.isView){
	  this.getTask(this.$route.params.name)
	}  
  },
  methods: {
	//任务详情
	getTask(id){
	  getTask(id).then(response => {
	    this.task = response.data
		this.dicdiagudsmeasureddataTypesValue = this.task.udsSetting.taskUdsReadMeasuredDataString.join(",")
	  })
	},    
    //任务类型选项
    getTaskTypes(){
      getTaskTypes().then(response => {
        this.taskTypes = response.data
      })
    },
    //通信协议选项
    getCommunication(){
      getCommunication().then(response => {
        this.communications = response.data
      })
    },
    //任务设备选项
    getTaskDevices(){
      getTaskDevices().then(response => {
		this.taskDevices = response.data.map(item => item.deviceIdentifier)
      })
    },
    //获取任务状态选项
    /*getTaskStatus(){
      getTaskStatus().then(response => {
        this.taskStatus = response.data
      })
    },*/
	//CAN Passthru的类型选项
	getDiccanpassthruType(){
      getDiccanpassthruType().then(response => {
        this.diccanpassthruTypes = response.data
      })
    },
	//CAN硬件类型选项
	getDiccandevicesType(){
      getDiccandevicesType().then(response => {
		this.diccandevicesTypes = response.data
      })
    },
	//测量项选项
	getDicdiagudsmeasureddataType(){
      getDicdiagudsmeasureddataType().then(response => {
		this.dicdiagudsmeasureddataTypesL = response.data
      })
    },
	//选择左边表格
	onRowSelectedL(items){
		console.log(items)
		this.dicdiagudsmeasureddataTypesLActive = items
	},
	//选择右边表格
	onRowSelectedR(items){
		console.log(items)
		this.dicdiagudsmeasureddataTypesRActive = items
	},
	//将左边表格项添加到右边
	addToR(){
		this.dicdiagudsmeasureddataTypesLActive.forEach((item)=>{
		  this.dicdiagudsmeasureddataTypesR.push(item);
		  let index = this.dicdiagudsmeasureddataTypesL.findIndex(function(litem) {
		    return litem.udsMeasuredDataIdentifier == item.udsMeasuredDataIdentifier;
		  });
		  this.dicdiagudsmeasureddataTypesL.splice(index, 1);
		})
		this.doneRemove()
	},
	//将右边表格项添加到左边
	addToL(){
		this.dicdiagudsmeasureddataTypesRActive.forEach((item)=>{
		  this.dicdiagudsmeasureddataTypesL.push(item);
		  let index = this.dicdiagudsmeasureddataTypesR.findIndex(function(litem) {
		    return litem.udsMeasuredDataIdentifier == item.udsMeasuredDataIdentifier;
		  });
		  this.dicdiagudsmeasureddataTypesR.splice(index, 1);
		})
		this.doneRemove()
	},
	//完成移动时执行
	doneRemove(){
		this.task.udsSetting.taskUdsReadMeasuredDataString = this.dicdiagudsmeasureddataTypesR.map(item => item.udsMeasuredDataIdentifier)
		this.dicdiagudsmeasureddataTypesLActive = []
		this.dicdiagudsmeasureddataTypesRActive = []
		this.dicdiagudsmeasureddataTypesValue = this.task.udsSetting.taskUdsReadMeasuredDataString.join(",")
	},
	//新增任务
    addTask(){
	  if(this.task.canSetting.taskComCanInterface!=3){
		  this.task.canSetting.taskComPassthruInterface = 0
	  }
	  this.$refs.addTaskRules.validate().then(success => {
	    if (success) {
	      addTask(this.task)
		  .then(response => {
		    this.$router.replace({ name: 'diagnostic-task-list' })
		        .then(() => {
		          this.$toast({
		            component: ToastificationContent,
		            position: 'top-right',
		            props: {
		              title: '添加成功',
		              icon: 'CoffeeIcon',
		              variant: 'success',
		              text: '添加任务成功 !',
		            },
		          })
		        })
		  })
	    }
	  })
    },
	//选择obd选项
	onChangeObdSettingModel(){
	  let num = 0;
	  let opts = this.task['obdSetting']	  
	  Object.keys(opts).map(key => {
		num = num+parseInt(opts[key]) 
	  });	
	  this.isObdSettingModel = num?num:null
	},
	//选择uds选项
	onChangeUdsSetting(){
	  let num = 0;
	  let opts = this.task.udsSetting	  
	  Object.keys(opts).map(key => {
		if(key!='taskUdsReadMeasuredDataString'){
		  num = num+parseInt(opts[key]) 	
		}
	  });	
	  this.isUdsSettingModel = num?num:null
	},
	//选择www-obd选项
	onChangeWwhObdSetting(){
	  let num = 0;
	  let opts = this.task.wwhobdSetting	  
	  Object.keys(opts).map(key => {
		num = num+parseInt(opts[key]) 
	  });	
	  this.isWwhObdSettingModel = num?num:null
	},
	//选择j1939选项
	onChangeJ1939Setting(){
	  let num = 0;
	  let opts = this.task.j1939Setting	  
	  Object.keys(opts).map(key => {
		num = num+parseInt(opts[key]) 
	  });	
	  this.isJ1939SettingModel = num?num:null
	}


  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';
.checkbox-group .custom-checkbox{
	margin-bottom: 10px;;
}
.card-header i{
	display: none;
}
</style>